import { LoanPropertyScreen } from "@/screens/loans/setup/LoanPropertyScreen"

import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { router } from "expo-router"

export default function LoanProperty() {
  const { save } = useLoanContext()

  async function onNext() {
    await save()
    router.push("./product")
  }

  return (
    <LoanPropertyScreen
      onSubmit={onNext}
      backButton={() => {
        router.push("./qualifications")
      }}
    />
  )
}
